export default __webpack_public_path__ + "static/media/Inventory-kits-gray-icon.d77fa479.svg";